<template>
  <div>
    <FormGroup>
      <FormField
        label="Monthly income"
        hint="2x the monthly rent in total household income is the typical standard nationwide"
        :error="form.fieldErrors('minimumIncome')"
      >
        <Select v-model="form.fields.minimumIncome">
          <option v-for="option in minimumIncomeOptions" :key="option" :value="option">{{ option }}</option>
        </Select>
      </FormField>

      <View direction="column" gap="sm">
        <FormField label="Minimum credit score" :error="form.fieldErrors('minimumCreditScore')">
          <Input v-model="form.fields.minimumCreditScore" type="number" />
        </FormField>

        <HintCollapsible
          class="hint"
          :initially-expanded="true"
          icon="question-mark-circle"
          label="Credit Score Ranges based on TransUnion"
        >
          <ul>
            <li v-for="option in minimumCreditScoreOptions" :key="option">
              <Text variant="body-small">{{ option }}</Text>
            </li>
          </ul>
        </HintCollapsible>
      </View>

      <FormField
        label="Accept co-signer"
        direction="row"
        label-position="after"
        :error="form.fieldErrors('acceptsCosigners')"
      >
        <Checkbox v-model="form.fields.acceptsCosigners" name="acceptsCosigners" />
      </FormField>
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
import {
  Checkbox,
  FormField,
  FormGroup,
  HintCollapsible,
  Input,
  Select,
  View,
  Text,
  useForm,
} from '@tallo/design-system';
import { RenterRequirementsMinimumIncome, minimumCreditScoreOptions } from '@tallo/property';

import { SavePropertyRenterRequirementsDto } from '../../dtos/save-renter-requirements.dto.interface';
import { usePropertyStore } from '../../stores/property.store';

const minimumIncomeOptions = Object.values(RenterRequirementsMinimumIncome);
const propertyStore = usePropertyStore();
const form = useForm<SavePropertyRenterRequirementsDto>({
  minimumIncome: propertyStore.property?.renterRequirements?.minimumIncome || RenterRequirementsMinimumIncome.X2_RENT,
  minimumCreditScore: propertyStore.property?.renterRequirements?.minimumCreditScore || 600,
  acceptsCosigners: propertyStore.property?.renterRequirements?.acceptsCosigners || null,
});

async function save() {
  return form.submit(async (fields) => await propertyStore.saveRenterRequirements(fields));
}

defineExpose({ save, form });
</script>

<style scoped lang="scss">
ul {
  list-style-type: disc;
  margin-left: var(--t-spacing-md);
}
</style>
